import { useState, useEffect } from "react";
import { fetchData } from "../../api";
import { Link } from 'react-router-dom';

const About = () => {
    const [aboutData, setAboutData] = useState(null);
    const [prideItems, setPrideItems] = useState([]);

    useEffect(() => {
        fetchData("about-page-headings", true).then(data => setAboutData(data?.[0]));
        fetchData("our-pride-items", true).then(data => setPrideItems(data));
    }, []);

    return (
        <section className="relative py-24 bg-gradient-to-br from-gray-50 via-white to-gray-100 overflow-hidden">
            {/* Decorative background */}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(40,103,102,0.04)_1px,transparent_0)] bg-[length:40px_40px] pointer-events-none"></div>
            <div className="absolute top-10 left-10 w-72 h-72 bg-gradient-to-br from-[#286766]/10 to-transparent rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 right-10 w-96 h-96 bg-gradient-to-tl from-[#27352C]/10 to-transparent rounded-full blur-3xl"></div>

            <div className="container mx-auto px-4 relative z-10">
                {/* Main Title */}
                <div className="text-center mb-20">
                    <h2 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-[#286766] via-[#27352C] to-[#286766] bg-clip-text text-transparent mb-6">
                        {aboutData?.title}
                    </h2>
                    <div className="w-24 h-1 bg-gradient-to-r from-[#286766] to-[#27352C] mx-auto rounded-full mb-8"></div>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        {aboutData?.description}
                    </p>
                </div>

                {/* Pride Section */}
                <div className="mb-20">
                    <h3 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#286766] to-[#27352C] bg-clip-text text-transparent text-center mb-10">
                        {aboutData?.OurPrideTitle}
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">
                        {prideItems.map((item, index) => (
                            <div
                                key={index}
                                className="relative bg-white/70 backdrop-blur-lg rounded-3xl shadow-2xl border border-gray-100 overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-3xl flex flex-col items-center text-center p-10"
                                style={{ animationDelay: `${index * 0.07}s`, animation: 'fadeInUp 0.6s ease-out forwards' }}
                            >
                                <div className="w-20 h-20 flex items-center justify-center object-cover rounded-2xl mb-6 bg-gradient-to-br from-[#286766]/20 to-[#27352C]/10 shadow-lg">
                                    {item.image?.url ? (
                                        <img src={`${process.env.NEXT_PUBLIC_STRAPI_URL || "https://api.bouwbedrijfgeluk.nl"}${item.image?.url}`} alt={item.title} className="h-12 w-12 object-contain" />
                                    ) : (
                                        <svg className="w-12 h-12 text-[#286766]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" strokeWidth="2" /><path d="M8 12l2 2 4-4" strokeWidth="2" /></svg>
                                    )}
                                </div>
                                <h4 className="text-xl font-bold text-[#286766] mb-2">{item.title}</h4>
                                <p className="text-gray-700 mb-2">{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Approach Section */}
                <div className="py-16 px-6 rounded-3xl bg-gradient-to-br from-[#286766]/10 to-[#27352C]/10 shadow-xl max-w-4xl mx-auto mb-20">
                    <h3 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#286766] to-[#27352C] bg-clip-text text-transparent text-center mb-6">
                        {aboutData?.ApproachTitle}
                    </h3>
                    <p className="text-lg text-gray-700 text-center mb-8">
                        {aboutData?.ApproachDescription}
                    </p>
                    <div className="flex justify-center">
                        <Link to="/contact">
                            <button className="inline-flex items-center gap-3 bg-gradient-to-r from-[#286766] to-[#27352C] text-white font-semibold py-4 px-10 rounded-xl hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-lg">
                                {aboutData?.ButtonText || 'Neem contact op'}
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            <style jsx>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </section>
    );
};

export default About;
